import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { SUTENTOSTRIBUTARIOS,ISustentosTributatriosPagingRes  } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchSustentosTributarios = ({
  page = 1,
  page_size = 10,
  nombre = '',
}: GetSustentosTributariosParams) => {
  return useQuery({
    queryKey: ['sustentos-tributarios', page, nombre, page_size],
    queryFn: async () => {
      return getSustentosTributarios({ page, nombre, page_size });
    },
  });
};

export const useGetSustentosTributarios = (id: string) => {
  return useQuery({
    queryKey: ['sustentos-tributarios', id],
    queryFn: async () => {
      return getSustentoTributario(id);
    },
  });
};

export const useCreateSustentosTributarios = (navigate: NavigateFunction, returnUrl: string,enableNavigation?: boolean) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSustentosTributarios,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sustentos-tributarios'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};

export const useUpdateSustentosTributarios = (navigate: NavigateFunction, returnUrl: string,noState?: boolean,
  enableNavigation?: boolean) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatecreateSustentosTributarios,
    onSuccess: () => {
      noState && queryClient.invalidateQueries({ queryKey: ['sustentos-tributarios'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};

///* axios
export type GetSustentosTributariosParams = {
  page?: number;
  page_size?: number;
  nombre?: string;
};

export type CreateSustentosTributariosParams = Omit<SUTENTOSTRIBUTARIOS, 'id_sustento_tributario'>;
export type UpdateSustentosTributariosParams = {
  id: string;
  data: CreateSustentosTributariosParams;
};

export const getSustentosTributarios = async (params?: GetSustentosTributariosParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<ISustentosTributatriosPagingRes>(
    `${urlBackend}api/v1/sustentos-tributarios/?${queryParams}`,
    true
  );
};

export const getSustentoTributario = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<SUTENTOSTRIBUTARIOS>(`${urlBackend}api/v1/sustentos-tributarios/${id}/`, true);

  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};

export const createSustentosTributarios = async (data: CreateSustentosTributariosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<SUTENTOSTRIBUTARIOS>(`${urlBackend}api/v1/sustentos-tributarios/`, data, true);

  setAlert(true, res.message, res.status);
  return res;
};

export const updatecreateSustentosTributarios = async ({ id, data }: UpdateSustentosTributariosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<SUTENTOSTRIBUTARIOS>(`${urlBackend}api/v1/sustentos-tributarios/${id}/`, data, true);

  setAlert(true, res.message, res.status);
  return res;
};
